import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { currentUserStore } from '../../../../CurrentUserStore';
import { findLinkBy } from '../../../../Links';
import { trackIntercomEvent } from '../../../../services/intercomTrackingService';
import LearningAdvisorTile from './LearningAdvisorTile';

interface Props {
  context: 'Home' | 'Learning Collections';
}

function LearningAdvisor({ context }: Props) {
  const navigate = useNavigate();

  const handleLearningAdvisorClick = () => {
    trackIntercomEvent(`${context} - Create a Collection - Learning Advisor`);
    navigate('/learning_collections/chatbot_preview');
  };

  return findLinkBy(
    { rel: 'create-learning-collection-v2-ai', method: 'post' },
    currentUserStore.links,
  )
    .map(() => (
      <LearningAdvisorTile
        customClassName="border-[#DEDEDE] bg-[#FCFCFC] hover:bg-[#F2F2F3] hover:border-[#C6C6C6]"
        chipColor="teal"
        descColor="dark-gray"
        onClick={handleLearningAdvisorClick}
      />
    ))
    .getOrElse(() => (
      <LearningAdvisorTile
        customClassName="border-[#dedede4c] bg-[#FAFAFA] cursor-no-drop"
        chipColor="inactive-gray"
        iconClass="opacity-30"
        titleColor="light-gray"
        descColor="gray"
      />
    ));
}
export default observer(LearningAdvisor);
